import {
  reactQueryGet,
  reactQueryPost,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { CommunityMemberCharge } from "@/react/types/CommunityMemberCharge";
import type { CommunityMemberRefund } from "@/react/types/CommunityMemberRefund";

export interface RefundChargeParams {
  chargeProcessorId: string;
  params: Record<string, unknown>;
}

export interface RefundChargeResponse {
  community_member_charge?: CommunityMemberCharge;
  community_member_refund?: CommunityMemberRefund;
}

export interface PaywallChargesIndexFilters {
  community_member_id?: string;
  community_member_public_uid?: string;
}

export interface PaywallChargesIndexParams {
  filters: PaywallChargesIndexFilters;
  order: Record<string, "desc" | "asc">;
  page: string | number;
  perPage: number;
  searchKey?: string;
}

const refundCharge = ({ chargeProcessorId, params }: RefundChargeParams) =>
  reactQueryPost<RefundChargeResponse>(
    internalApi.admin.paywalls.charges.refunds({ chargeProcessorId }),
    params,
  );

const index = ({
  filters,
  order,
  page,
  perPage,
  searchKey,
}: PaywallChargesIndexParams) => {
  const searchKeyObject = searchKey
    ? {
        search_key: searchKey,
      }
    : {};

  return () =>
    reactQueryGet(
      internalApi.admin.paywalls.charges.index({
        params: {
          filters,
          page,
          per_page: perPage,
          order,
          ...searchKeyObject,
        },
      }),
    );
};

export const paywallChargesApi = {
  index,
  refundCharge,
};
